import { FormEvent, ReactElement } from "react";
import { Link } from "react-router-dom";

import { TranslationService } from "../../services/TranslationService";
import SubmitButton from "./components/SubmitButton";
import { InfoMessage } from "./components/InfoMessage";
import { HomeErrorMessage } from "./AuthSite";
import { useLogonForm } from "./hooks/useLogonForm";
import Footer from "../shared/Footer";
import intizaLogoWhite from "../../assets/img/IntizaLogoWhite.svg";
import "./logonV2.css";

/** Propuesta de login split-screen, detrás del feature flag "newLogin". */
function LogonV2(): ReactElement {
  const {
    formData,
    loading,
    visiblePassword,
    hasMessage,
    messageContent,
    handleLogIn,
    handleVisiblePassword,
    handleInputChange
  } = useLogonForm();
  const { translate, currentLanguage } = TranslationService;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!loading) handleLogIn();
  };

  return (
    <main className="logon-v2">
      <section className="logon-v2__hero">
        <img className="logon-v2__logo" src={intizaLogoWhite} alt="intiza" />
        <div className="logon-v2__hero-copy">
          <h2 className="logon-v2__hero-title">{translate.LoginHeroTitle}</h2>
          <p className="logon-v2__hero-subtitle">
            {translate.LoginHeroSubtitle}
          </p>
        </div>
      </section>

      <section className="logon-v2__panel">
        <div className="logon-v2__panel-body">
          <form className="logon-v2__card" onSubmit={handleSubmit} noValidate>
            <h1 className="logon-v2__title">{translate.Login}</h1>

            {hasMessage && <InfoMessage currentInfoMsg={messageContent} />}
            <HomeErrorMessage />

            <div className="logon-v2__field">
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="username"
                placeholder={translate.Email}
                aria-label={translate.Email}
                value={formData.email}
                onChange={handleInputChange}
              />
              <i
                className="fas fa-user logon-v2__field-icon"
                aria-hidden="true"
              />
            </div>

            <div className="logon-v2__field">
              <input
                type={visiblePassword ? "text" : "password"}
                id="password"
                name="password"
                autoComplete="current-password"
                placeholder={translate.Password}
                aria-label={translate.Password}
                value={formData.password}
                onChange={handleInputChange}
              />
              <button
                type="button"
                className="logon-v2__field-icon logon-v2__field-toggle"
                aria-label={translate.ShowPassword}
                aria-pressed={visiblePassword}
                onClick={handleVisiblePassword}
              >
                <i
                  className={`fas fa-${visiblePassword ? "un" : ""}lock-alt`}
                  aria-hidden="true"
                />
              </button>
            </div>

            <div className="logon-v2__forgot">
              <Link to={`/${currentLanguage}/home/recoverpassword`}>
                {translate.PasswordForgotten}
              </Link>
            </div>

            <label className="logon-v2__remember" htmlFor="remember">
              <input
                type="checkbox"
                id="remember"
                name="remember"
                checked={formData.remember}
                onChange={handleInputChange}
              />
              {translate.RememberMe}
            </label>

            <SubmitButton
              type="submit"
              fullWidth
              text={translate.Login.toUpperCase()}
              loading={loading}
            />
          </form>
        </div>
        <Footer variant="minimal" />
      </section>
    </main>
  );
}

export default LogonV2;
